// Port of api/fuel/app/classes/filter/search/games/filters/post/random.php
export default {
	name: 'post.random',
	priority: 10,
	post: true,
	require: function(config, filter) {
		return filter.random > 0
	},
	run: function(config, filter, data, results) {
		var shuffled = results.index.slice()
		for (var i = shuffled.length - 1; i > 0; i--) {
			var j = Math.floor(Math.random() * (i + 1))
			var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp
		}
		var limit = filter.limit > 0 ? Math.min(filter.limit, filter.random) : filter.random
		shuffled = shuffled.slice(0, limit)
		// Re-sort to original order
		var indexMap = {}
		for (var k = 0; k < results.index.length; k++) indexMap[results.index[k]] = k
		shuffled.sort(function(a, b) { return (indexMap[a] || 0) - (indexMap[b] || 0) })
		results.index = shuffled
		return results
	}
}
